import { BuildFilters } from './RequestBuilder';
import ResourceTyped, { Metadata } from './ResourceTyped';
import Agreement from 'App/resources/Model/Agreement';

export type NextOrderPreview = {
	orderDate: string;
	startDate: string;
	endDate: string;
	value: number;
	currency: string;
};

class AgreementResource extends ResourceTyped<Agreement> {
	constructor() {
		super('agreements');
	}

	getAgreementsWithtoutConflicts = async (
		filters: BuildFilters,
		indexId?: number
	): Promise<{
		data: Agreement[];
		metadata: Metadata;
		err: Error;
	}> => {
		return super
			._getRequest('withoutConflicts', {
				methodName: 'getAgreementsWithtoutConflicts',
				params: { filters, indexId }
			})
			.then(res => res.data);
	};

	getAgreementsWithConflicts = async (
		filters: BuildFilters,
		indexId?: number
	): Promise<{
		data: Agreement[];
		metadata: Metadata;
		err: Error;
	}> => {
		return super
			._getRequest('withConflicts', {
				methodName: 'getAgreementsWithConflicts',
				params: { filters, indexId }
			})
			.then(res => res.data);
	};

	/** The order generateNextOrder would create: its order date, period and amount. Null when there is none. */
	previewNextOrder(id: number): Promise<NextOrderPreview | null> {
		return this._getRequest(`${id}/nextOrder`, { methodName: 'previewNextOrder' }).then(
			({ data }: { data: { data: NextOrderPreview | null } }) => data.data
		);
	}

	/** The next order, created now instead of on its order date. Null when there is none to bring forward. */
	generateNextOrder(id: number): Promise<{ id: number } | null> {
		return this._postRequest(`${id}/generateNextOrder`, {}, { methodName: 'generateNextOrder' }).then(
			({ data }: { data: { data: { id: number } | null } }) => data.data
		);
	}
}

const resource = new AgreementResource();

export default resource;
